<div class="flex flex-col text-center min-h-screen p-6 pt-10">

  <!-- Header Bar (Top) -->
  <h1 mat-dialog-title id="addnewsite" class="mb-4">
    <div class="flex justify-between items-center">
      <div class="text-xl font-semibold">
        Common Drug Database Management - Support Request
      </div>
      <div>
        <mat-icon (click)="dialogRef.close()" class="cursor-pointer">
          <img src="/assets/img/icons/ico.16.clear.svg" alt="Close">
        </mat-icon>
      </div>
    </div>
  </h1>

  <!-- Content with More Top Gap Below Header -->
  <div class="flex flex-col justify-center items-center gap-16 mt-16">

    <!-- Enhancement Request -->
    <div class="flex flex-col items-center">
      <div class="text-base font-medium mb-3 text-gray-700">
        Submit an Idea
      </div>
      <a href="https://secure.aha.io/session/new?requested_domain=parataputsyououtinfront" target="_blank" rel="noopener noreferrer">
        <button class="btn-primary btn btn-md">
          Enhancement Request
        </button>
      </a>
    </div>

    <!-- Support -->
    <div class="flex flex-col items-center">
      <div class="text-base font-medium mb-3 text-gray-700">
        Need Assistance?
      </div>
      <a href="https://forms.office.com/pages/responsepage.aspx?id=fObDlC2eAEimt2Ndl4ghZeOBdHQQHTJImhXKqJd3eTNUOU04U0hLRVVMSk45NlNTWElTWElBUUVDVC4u&route=shorturl" target="_blank" rel="noopener noreferrer">
        <button class="btn-primary btn btn-md">
          Contact Support
        </button>
      </a>
    </div>

  </div>

</div>


<!-- <div>
  <h1 mat-dialog-title id="addnewsite" style="margin: 0px 1px 13px 1px; ">
    <div class="flex justify-start content-center items-center flex-row">
        <div class="flex flex-row justify-start content-stretch items-stretch h-full basis-1/2">
          Common Drug Database Management
        </div>
        <div class="flex flex-row justify-end content-stretch items-stretch h-full basis-1/2">
            <mat-icon (click)="dialogRef.close()" class="cross-wizard">
                <img src="/assets/img/icons/ico.16.clear.svg" alt="">
            </mat-icon>
        </div>

    </div>
</h1>
<div>
    <p style="padding-left:23px;"><b>Accepted file formats are .xlsx, .xls, and .csv.</b></p>
<div style="margin-bottom: 10px;" class="flex flex-row flex-wrap">
    <div class="flex flex-col basis-[32%] md:basis-[32%] xs:basis-full sm:basis-1/2">
    <app-synmed-fileupload></app-synmed-fileupload>
    </div>
    <div class="flex flex-col basis-[32%] md:basis-[32%] xs:basis-full sm:basis-1/2">
    <app-petmed-fileupload></app-petmed-fileupload>
    </div>
    <div class="flex flex-col basis-[32%] md:basis-[32%] xs:basis-full sm:basis-1/2">
    <app-snapcanister-fileupload></app-snapcanister-fileupload>
    </div>
</div>
    <app-cddb-automation-script></app-cddb-automation-script>
</div>


</div> -->
